import { createTheme } from '@mui/material/styles';

const globalTheme = createTheme({
    palette: {
        primary: {
            main: "#002776"
        },
        success: {
            main: "#00975F"
        }
    },
    typography: {
        fontFamily: 'Sparebank1-regular, Arial, sans-serif',
        h1: {
            fontFamily: 'Sparebank1-title-medium, Arial, sans-serif'
        }
    }
})




export default globalTheme